import axios from 'axios';

const baseURL = 'https://studentapi.anginatlearning.com/api/student';

// Track refresh promise to prevent multiple refresh calls
let isRefreshing = false;
let refreshPromise = null;
let failedQueue = [];

// Process the queue of failed requests
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Create axios instance
const axiosInstance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false
});

// Request interceptor for adding the auth token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling token refresh
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        // Only handle 401 errors for non-auth endpoints to prevent infinite loops
        if (error.response?.status === 401 && 
            !originalRequest._retry && 
            !originalRequest.url?.includes('/auth/refresh-token')) {
            
            originalRequest._retry = true;

            // If already refreshing, queue this request
            if (isRefreshing) {
                try {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                    .then(token => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return axiosInstance(originalRequest);
                    })
                    .catch(err => {
                        // Handle failed refresh - don't redirect immediately
                        // Just reject the promise to allow component-level error handling
                        return Promise.reject(err);
                    });
                } catch (error) {
                    return Promise.reject(error);
                }
            }

            isRefreshing = true;
            
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (!refreshToken) {
                    throw new Error('No refresh token available');
                }

                // Use a direct axios call to avoid interceptors for the refresh call itself
                const response = await axios.post(`${baseURL}/auth/refresh-token`, {
                    refreshToken,
                }, {
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.data.status === 'success') {
                    const { accessToken, refreshToken: newRefreshToken } = response.data.data;
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', newRefreshToken);
                    
                    // Update all queued requests with the new token
                    processQueue(null, accessToken);
                    
                    // Update original request and retry
                    originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                    return axiosInstance(originalRequest);
                } else {
                    // Refresh failed with a non-error response
                    processQueue(new Error('Failed to refresh token'));
                    throw new Error(response.data.message || 'Failed to refresh token');
                }
            } catch (refreshError) {
                processQueue(refreshError);
                console.error('Token refresh failed:', refreshError);
                
                // Clear auth data
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('userData');
                
                // Only redirect to login if it's a page load, not an API call
                // Let the component handle API failures
                if (!originalRequest.headers['X-Requested-With'] === 'XMLHttpRequest') {
                    // Add a delay to prevent immediate redirection
                    setTimeout(() => {
                        window.location.href = '/login?session=expired';
                    }, 500);
                }
                
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        // Return the error for handling at the component level
        return Promise.reject(error);
    }
);

export default axiosInstance;

/**
 * 
 * import axios from 'axios';

const baseURL = 'https://studentapi.anginatlearning.com/api/student';

// In AxiosInstance.js
const axiosInstance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false
});

// Track refresh promise to prevent multiple refresh calls
let isRefreshing = false;
let refreshPromise = null;
let failedQueue = [];

// Process the queue of failed requests
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Request interceptor for adding the auth token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling token refresh
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        // Only handle 401 errors for non-auth endpoints to prevent infinite loops
        if (error.response?.status === 401 && 
            !originalRequest._retry && 
            !originalRequest.url?.includes('/auth/refresh-token')) {
            
            originalRequest._retry = true;

            // If already refreshing, queue this request
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                .then(token => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    return axiosInstance(originalRequest);
                })
                .catch(err => {
                    return Promise.reject(err);
                });
            }

            isRefreshing = true;
            
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (!refreshToken) {
                    throw new Error('No refresh token available');
                }

                // Use a direct axios call to avoid interceptors for the refresh call itself
                const response = await axios.post(`${baseURL}/auth/refresh-token`, {
                    refreshToken,
                }, {
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.data.status === 'success') {
                    const { accessToken, refreshToken: newRefreshToken } = response.data.data;
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', newRefreshToken);
                    
                    // Update all queued requests with the new token
                    processQueue(null, accessToken);
                    
                    // Update original request and retry
                    originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                    return axiosInstance(originalRequest);
                } else {
                    // Refresh failed with a non-error response
                    processQueue(new Error('Failed to refresh token'));
                    throw new Error(response.data.message || 'Failed to refresh token');
                }
            } catch (refreshError) {
                processQueue(refreshError);
                console.error('Token refresh failed:', refreshError);
                
                // Clear auth data
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('userData');
                
                // Force redirect to login
                window.location.href = '/login?session=expired';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
 */